export default __webpack_public_path__ + "static/media/Valet.84eca67c.png";